import { styled } from "@mui/material/styles";
import { Step } from "@mui/material";

export const AcxStep = styled(Step)(({ theme }) => ({
    minWidth: "132px",
    height: "38px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "0",
    padding: theme.spacing(0, 1),

    // Define classes for conditional styling
    ".MuiButtonBase-root": {
        padding: theme.spacing(0, 3, 0, 3),
        left: theme.spacing(1.5),
        height: "100%",
        width: "100%",
        color: theme.palette.gray[500],
        fontSize: "14px",
        fontWeight: 500,
    },

    "&.active": {
        backgroundColor: "white",
        position: "relative",
        color: theme.palette.neutral.dark,

        ".MuiButtonBase-root": {
            color: theme.palette.neutral.dark,
            fontWeight: 600,
        },

        // right arrow
        ":not(.last)&::after": {
            content: '""',
            position: "absolute",
            right: "-15px",
            borderLeft: "15px solid transparent",
            borderRight: "15px solid white",
            borderTop: "15px solid white",
            borderBottom: "15px solid transparent",
            borderRadius: "15%",
            transform: "rotate(45deg)",
        },

        // left arrow
        ":not(.first)&::before": {
            content: '""',
            position: "absolute",
            left: "-15px",
            borderLeft: "15px solid transparent",
            borderRight: `15px solid ${theme.palette.gray[200]}`,
            borderTop: `15px solid ${theme.palette.gray[200]}`,
            borderBottom: "15px solid transparent",
            borderRadius: "15%",
            transform: "rotate(45deg)",
        },
    },
    "&.inactive": {
        backgroundColor: theme.palette.gray[200],
        color: theme.palette.gray[500],
    },
    "&.disabled": {
        backgroundColor: "#ECEDF0",
    },
    "&.first": {
        borderRadius: "19px 0 0 19px",
    },
    "&.last": {
        borderRadius: "0 19px 19px 0",
        paddingRight: theme.spacing(4),
    },
}));
